import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
          <i className="ri-archive-drawer-fill" /> 漫画分类
        </span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">按口味找到你的菜</h2>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
          六大热门分类，总有适合你的追更方向
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
        {categories.map((c) => (
          <Link
            key={c.id}
            to={`/category/${c.id}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50 transition-colors group-hover:bg-primary-600">
              <i className={c.icon} />
            </span>
            <div className="min-w-0">
              <h3 className="text-base font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-0.5 truncate text-xs text-foreground-500">{c.desc}</p>
              <p className="mt-1 text-[11px] font-medium text-primary-600">{c.count} 部作品</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}